// extracted by mini-css-extract-plugin
module.exports = {"image":"LocationView_image__2zFQP"};